<div class="popover" [style.width.px]="width()" (keyup.enter)="handleSearch()">
  <div class="popover-keywords">
    Keyword:
    <app-simple-input
      class="popover-keywords-input"
      placeholder="Type to search"
      [inputFormControl]="inputControl"
      [withClear]="true"
      [noBorder]="true"
      [focusImmediately]="true"
    />
  </div>

  @if (listStore.markers().knots.length) {
    <div class="popover-knowledge knots padding">
      <div class="popover-knowledge-label">Knots:</div>
      @for (knot of listStore.markers().knots; track knot.id) {
        <app-knot
          class="popover-knowledge-item"
          [knot]="knot"
          [withControls]="false"
          [withRemove]="true"
          (onRemove)="removeKnowledgeItem(knot)"
        />
      }
    </div>
  }

  @if (listStore.markers().tags.length) {
    <div class="popover-knowledge tags padding">
      <div class="popover-knowledge-label">Tags:</div>
      @for (tag of listStore.markers().tags; track tag.id) {
        <app-tag
          class="popover-knowledge-item"
          [tag]="tag"
          [withControls]="false"
          [withRemove]="true"
          (onRemove)="removeKnowledgeItem(tag)"
        />
      }
    </div>
  }

  @if (listStore.markers().connections.length) {
    <div class="popover-knowledge connections padding">
      <div class="popover-knowledge-label">Connections:</div>
      @for (connection of listStore.markers().connections; track connection.id) {
        <app-connection
          class="popover-knowledge-item"
          [connection]="connection"
          [withControls]="false"
          [withRemove]="true"
          (onRemove)="removeKnowledgeItem(connection)"
        />
      }
    </div>
  }

  <div class="popover-buttons">
    <app-button2 class="popover-buttons-item" appearance="secondary" size="m" (click)="handleCancel()">Cancel</app-button2>
    <app-button2 class="popover-buttons-item" appearance="primary" size="m" (click)="handleSearch()">Search</app-button2>
  </div>
</div>
